import { gql } from '@apollo/client';

export const FETCH_MOD_FLAGS = gql`
  query {
    unresolvedModeratorFlagCounts
  }
`;
